module.exports = __webpack_public_path__ + "static/media/businessmanhover.d6e2bc9d.svg";